export const SETTING_FIELD_TYPE = {
  number: 'number',
  text: 'text',
  choice: 'choice',
  duration: 'duration',
} as const;

export type SettingFieldType = (typeof SETTING_FIELD_TYPE)[keyof typeof SETTING_FIELD_TYPE];

export const SETTING_FIELD_TYPE_OPTIONS: SettingFieldType[] = [
  SETTING_FIELD_TYPE.number,
  SETTING_FIELD_TYPE.text,
  SETTING_FIELD_TYPE.choice,
  SETTING_FIELD_TYPE.duration,
];

export const CATEGORY_COLOR_SWATCHES: string[] = [
  '#5850a0',
  '#4457b0',
  '#3c8a58',
  '#9a7632',
  '#a33a3a',
  '#7870b0',
  '#2f8f8a',
  '#5b6472',
];

export const DEFAULT_CATEGORY_COLOR = '#5850a0';
